<template>
    <section class="user-settings">
        <template v-if="busy">
            <CenteredMessage :spinner="true">Benutzereinstellungen werden geladen...</CenteredMessage>
        </template>
        <template v-else>
            <b-form-group
                v-for="setting in data"
                :key="setting.key"
                :label-cols-sm="3"
                :label-cols-lg="4"
                :label-for="setting.key"
                :label-size="size"
                :label="setting.nicename"
            >
                <b-input :size="size" v-model="setting.value" @update="update" />
            </b-form-group>
        </template>
    </section>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Size from "@/mixins/Size/Size";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";

const BenutzerverwaltungApi = ApiFactory.get("benutzerverwaltung");

export default {
    name: "UserSettings",
    components: {
        CenteredMessage
    },
    mixins: [Size],
    props: ["id"],
    data() {
        return {
            ioFields: [],
            values: [],
            data: [],
            busy: false
        };
    },
    watch: {
        id: {
            handler(val) {
                this.fetchSettings(val);
            },
            immediate: true
        }
    },
    methods: {
        async fetchSettings(id) {
            this.busy = true;
            const response = await BenutzerverwaltungApi.getSettings(id);
            if (response.ok) {
                var data = response.json.collection;
                var fields = data.map(item => {
                    return {
                        key: item.key,
                        label: item.nicename
                    };
                });
                var values = [];
                data.forEach(item => {
                    values[item.key] = item.value;
                });
                this.ioFields = fields;
                this.data = data;
                this.values = values;
            }
            this.busy = false;
        },
        update(value) {
            this.$emit("update", this.data);
        }
    }
};
</script>